<template>
  <div>
    <BaseFCPAutoComplete2
      :elementId="id"
      :options="autoCompleteOptions"
      :label="label"
      :required="required"
      :hideSearchButton="hideSearchButton"
      :initialValue="initialValue"
      v-on:onSelected="onSelected"
      v-on:onInputChange="onInputChange"
      :helpText="helpText"
      :showOptionalLabel="showOptionalLabel"
      v-model="inputText"
    />
  </div>
</template>

<script setup>
/**
 * Provides a Places/GeoLocator component for selecting Latitude and longitude based upon as you type address, zip etc.
 * It builds on top of the FCPAutocomplete component and leverages the MapBox Geocoding API.
 */

  const props = defineProps({
    id: String,
    initialValue: String,
    label: String,
    helpText: String,
    required: {
      type: Boolean,
      default: false
    },
    hideSearchButton: {
      type: Boolean,
      default: true
    },
    showOptionalLabel: {
      type: Boolean,
      default: true
    }
  })

  const emit = defineEmits(['selected', 'inputchange'])

  // Mapbox temporary token is fetched and saved in the model
  const { context, mapboxToken } = useFCPModel()
  const inputText = ref(props.initialValue)
  const mapBoxProximity = computed(() => {
    const latLngStr = context.latLong ? context.latLong : '44.9778,-93.2650'
    const props = latLngStr.split(',')
    //We store latLngs as latitude,longitude, but mapBox wants them in the reverse order.
    return [parseFloat(props[1]), parseFloat(props[0])]
  })

  const autocomplete = async (query, props) => {
    const { browserGeoLocate } = useGeolocation()
    const result = await browserGeoLocate(query, props, mapboxToken.value)

    if (result) {
      //Filter out only the types we care about ( postcode and place types )
      return result.features.filter((f) => f.place_type[0] == 'place' || f.place_type[0] == 'postcode')
    }

    return ''
  }

  //Custom function for displaying menu selections and the selected items in the input box.
  const getResultValue = (val) => {
    return val.place_name
  }

  //Callback function for providing geocoding selections to the autocomplete control.  Talks to the
  //MapBox API.
  const search = (input) => {
    //if (input && input.length > 2) {
    if ( input ) {
      return autocomplete(input, { proximity: mapBoxProximity.value, autocomplete: true, types: ['place', 'postcode'] })
    }
  }

  /**
   * Event fired when the autocomplete control emits a 
   */
  const onSelected = (val) => {

    if ( val ) {
      const event = {
        zip: val.place_type[0] == 'postcode' ? val.text : '',
        name: val.place_name,
        latitude: val.geometry.coordinates[1],
        longitude: val.geometry.coordinates[0],
      }
      
      emit('selected', event)
    }
    else {
      emit('selected', null)
    }
  }

  /**
   *  When the input changes on the autocomplete, make sure to notify the user.
   */ 
  const onInputChange = (event) => {
    emit("inputchange", event)
  }

  const displayFunction = (val) => {
    return val.place_name
  }

  const autoCompleteOptions = {
    search: search,
    // getResultValue: (r) => {
    //   //console.log("getResultValue", r)
    //   //return r.place_name
    // }
    getResultValue: displayFunction
  }

</script>

<style scoped>
FCPAutoComplete2 {
  width: 100%;
}
</style>